module.exports = __webpack_public_path__ + "static/media/CHAP03-PHOTO-SAM-JOUEURS.e4dc45c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP03-PHOTO-SAM-JOUEURS.png
// module id = 288
// module chunks = 0